module.exports = __webpack_public_path__ + "media/control_acceso/cerradura_salto-a4b12e30.png";